import React from "react";
import { StyledActionMenuSeparatorLi, StyledActionMenuSeparatorLine } from "./ActionMenuSeparator.style";
const ActionMenuSeparator = () => (React.createElement(StyledActionMenuSeparatorLi, { role: "separator" },
    React.createElement(StyledActionMenuSeparatorLine, null)));
export default ActionMenuSeparator;
//# sourceMappingURL=ActionMenuSeparator.js.map